import moment, { Moment } from 'moment';

export const beforeToday = (day: Moment, value?: Moment): boolean => {
  if (!value) {
    return day.isBefore(new Date(), 'day');
  } else {
    return day.isBefore(value, 'day');
  }
};

export const beforeTomorrow = (day: Moment, value?: Moment): boolean => {
  const tomorrow = moment().add(1, 'days');
  if (!value) {
    return day.isBefore(tomorrow, 'day');
  } else {
    return day.isBefore(value, 'day');
  }
};

export const afterToday = (day: Moment, value?: Moment): boolean => {
  if (!value) {
    return day.isAfter(new Date(), 'day');
  } else {
    return day.isAfter(value, 'day');
  }
};

const isSelected = (day: Moment, value?: Moment | null): boolean => {
  if (value) {
    return value.isSame(day, 'day');
  }
  return false;
};

const isToday = (day: Moment, value?: Moment): boolean => {
  if (!value) {
    return day.isSame(new Date(), 'day');
  } else {
    return day.isSame(value, 'day');
  }
};

interface StyleDatesProps {
  day: Moment;
  value?: Moment | null;
  variant?: string;
  from?: Moment;
  to?: Moment;
  selectableDates?: 'all' | 'future' | 'current/future' | 'current/past';
  currentMonth: string;
}

export const styleDates = ({
  day,
  value,
  variant,
  from,
  to,
  selectableDates,
  currentMonth,
}: StyleDatesProps): string => {
  if (
    variant &&
    variant === 'range' &&
    from &&
    day.isBetween(value, from, 'days', '()')
  )
    return 'bg-thryv-white-300 rounded-md text-thryv-black-500 cursor-pointer';

  if (
    variant &&
    variant === 'range' &&
    to &&
    from &&
    day.isBetween(from, to, 'days', '()')
  )
    return 'bg-thryv-white-300 rounded-md text-thryv-black-500 cursor-pointer';

  if (!variant && isSelected(day, value))
    return `bg-black rounded-md text-white cursor-pointer`;

  if (variant && variant === 'range' && isSelected(day, value))
    return `bg-black rounded-md text-white cursor-pointer`;

  if (!variant && isToday(day) && selectableDates !== 'future')
    return `border border-thryv-orange-500 text-thryv-orange-500 rounded-md cursor-pointer`;

  if (variant && variant === 'range')
    return 'text-thryv-black-500 cursor-pointer';

  if (!variant && day.format('MMMM') !== currentMonth)
    return 'text-[#C2C2C2] cursor-pointer';

  if (beforeToday(day) && selectableDates === 'current/future')
    return `text-[#C2C2C2]`;

  if (beforeTomorrow(day) && selectableDates === 'future')
    return `text-[#C2C2C2]`;

  if (afterToday(day) && selectableDates === 'current/past')
    return `text-[#C2C2C2]`;

  return `text-thryv-black-500 cursor-pointer hover:border hover:border-black hover:rounded-md`;
};

export const styleRangeDates = (
  day: Moment,
  from?: Moment,
  to?: Moment,
  selectableDates?: 'all' | 'future' | 'current/future' | 'current/past',
  activeSelection?: 'start' | 'end' | '',
  currentMonth?: string
): string => {
  if (day.format('MMMM') !== currentMonth) {
    return '!hidden';
    // return 'text-[#C2C2C2] cursor-pointer';
  }
  if (from && activeSelection === 'start' && isSelected(day, from))
    return `bg-black rounded-md text-white cursor-pointer`;

  if (to && activeSelection === 'start' && isSelected(day, to))
    return `bg-white rounded-md border border-black text-black cursor-pointer`;

  if (from && activeSelection === 'end' && isSelected(day, from))
    return `bg-white rounded-md border border-black text-black cursor-pointer`;

  if (to && activeSelection === 'end' && isSelected(day, to))
    return `bg-black rounded-md text-white cursor-pointer`;

  if (to && from && day.isBetween(from, to, 'days', '()'))
    return 'bg-thryv-white-300 rounded-md text-thryv-black-500 cursor-pointer';

  // if (beforeToday(day) && selectableDates !== 'future') return `text-[#C2C2C2]`;

  if (beforeToday(day) && selectableDates === 'current/future')
    return `text-[#C2C2C2]`;

  if (beforeTomorrow(day) && selectableDates === 'future')
    return `text-[#C2C2C2]`;

  if (afterToday(day) && selectableDates === 'current/past')
    return `text-[#C2C2C2]`;

  return `text-thryv-black-500 cursor-pointer rounded-md hover:bg-white hover:border hover:border-black hover:text-black`;
};
